import { render, staticRenderFns } from "./AddEditLeaves.vue?vue&type=template&id=404d407f&scoped=true"
import script from "./AddEditLeaves.vue?vue&type=script&lang=js"
export * from "./AddEditLeaves.vue?vue&type=script&lang=js"
import style0 from "./AddEditLeaves.vue?vue&type=style&index=0&id=404d407f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404d407f",
  null
  
)

export default component.exports